export const SCROLL_EVENT = 'scroll';
export const SCROLL_THRESHOLD = 300;
export const SCROLL_BEHAVIOR = 'smooth';
